import Button from 'src/components/atoms/Button';
import Page from 'src/components/layouts/Page';
import TwoColumn from 'src/components/layouts/TwoColumn';
import InputWrap from 'src/components/molecules/InputWrap';
import css from './ItemDetails.module.scss';
import PageButtonsBar from 'src/components/organisms/PageButtonsBar';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AddonBox2 from 'src/components/organisms/AddonBox2';
import CropModal from 'src/components/modals/CropModal';
import Croppedimages from 'src/components/organisms/Croppedimages';
import Checkbox from 'src/components/atoms/Checkbox';
import item, { addItem, clearState, getItemDetails, updateItem } from 'src/slices/item';
import { handleStatus } from 'src/slices/utils';

export default function ItemDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { item: itemId } = useParams();
  const { itemDetails, status } = useSelector((state) => state.item);
  const { permissions } = useSelector((state) => state.auth);
  const [details, setDetails] = useState(itemDetails);
  const [restrictions, setRestrictions] = useState({});
  const [addOns, setAddOns] = useState([]);

  // On load
  useEffect(() => {
    if (itemId != 'new') {
      dispatch(getItemDetails(itemId));
    } else {
      dispatch(clearState(status.addItem));
    }
  }, []);

  // UI updates
  useEffect(() => {
    handleStatus(status.addItem, () => dispatch(clearState(status.addItem)), {
      isSuccess: {
        callback: () =>
          permissions.create.includes('items') ? navigate('/items') : navigate('/pending-items'),
      },
    });
    handleStatus(status.updateItem, () => dispatch(clearState(status.updateItem)), {
      isSuccess: {
        callback: () =>
          itemDetails.status != 'pending' ? navigate('/items') : navigate('/pending-items'),
      },
    });
  }, [status]);

  useEffect(() => {
    setDetails(itemDetails);
    setAddOns(itemDetails?.addOns);
    setRestrictions({
      vegetarian: itemDetails?.restrictions?.includes('vegetarian'),
      vegan: itemDetails?.restrictions?.includes('vegan'),
      halal: itemDetails?.restrictions?.includes('halal'),
      kosher: itemDetails?.restrictions?.includes('kosher'),
    });
  }, [itemDetails]);

  const updateField = (field, value) => {
    setDetails({ ...details, [field]: value });
  };

  const inputValidator = (item) => {
    if (!item.name) {
      toast.warning(`"name" is a required field`);
      return null;
    } else if (!item.price) {
      toast.warning(`"Price" is required field"`);
      return null;
    } else if (!item.description) {
      toast.warning(`"Description" is a required field`);
      return null;
    } else if (addOns?.some((addOn) => !addOn.title)) {
      toast.warning(`Addons must have at name`);
      return null;
    } else if (addOns?.some((addOn) => addOn.options?.some((option) => !option.name))) {
      toast.warning(`Addons must have at least one named choice`);
      return null;
    }
    return item;
  };

  const handleSave = async () => {
    const {} = {};
    const data = {
      ...details,
      addOns: JSON.stringify(
        addOns.map((addOn) => ({
          ...addOn,
          id: addOn._id,
          type: !addOn._id ? 'create' : 'update',
        })),
      ),
      restrictions: JSON.stringify(Object.keys(restrictions).filter((val) => restrictions[val])),
      id: itemId,
    };
    if (inputValidator(data)) {
      itemId == 'new' ? dispatch(addItem(data)) : dispatch(updateItem(data));
    }
  };

  // const handleClear = () => {
  //   if (itemId) {
  //     setDetails(itemDetails);
  //     return;
  //   }
  //   setDetails({
  //     name: '',
  //     description: '',
  //     price: 0,
  //     addOns: [],
  //     category: '',
  //     categoryIcon: '',
  //     restrictions: [],
  //     qty: {},
  //     photos: [],
  //   });
  // };

  // Addon fields

  const addAddon = () => {
    setAddOns([
      ...addOns,
      {
        title: '',
        // required: false,
        limit: '1',

        options: [
          {
            name: '',
            price: '0',
          },
        ],
      },
    ]);
  };

  const updateAddon = (index, field, value) => {
    const temp = [...addOns];
    setAddOns([...temp.map((addOn, idx) => (idx == index ? { ...addOn, [field]: value } : addOn))]);
  };

  const removeAddon = (index) => {
    setAddOns(addOns.filter((val, i) => i !== index));
  };

  // Option fields
  const addOption = (index) => {
    const value = [...addOns[index].options, { name: '', price: '0' }];

    updateAddon(index, 'options', value);
  };

  const updateAddonChoice = (index, choiceIndex, value, field) => {
    const temp = [...addOns];

    setAddOns(
      temp.map((addOn, idx) =>
        idx == index
          ? {
              ...addOn,
              options: addOn.options.map((choice, choiceIdx) =>
                choiceIndex == choiceIdx ? { ...choice, [field]: value } : choice,
              ),
            }
          : addOn,
      ),
    );
  };

  const removeAddonChoice = (index, choiceIndex) => {
    const temp = [...addOns];
    setAddOns([
      ...temp.map((addOn, idx) =>
        idx == index
          ? {
              ...addOn,
              options: addOn.options.filter((val, i) => i !== choiceIndex),
            }
          : addOn,
      ),
    ]);
  };

  /*
	Images
	*/

  const [cropImage, setCropImage] = useState();
  const [showModal, setShowModal] = useState(false);

  const addImage = (photo) => {
    updateField('photos', [...details.photos, photo]);
  };
  const removeImage = (photo) => {
    updateField(
      'photos',
      details.photos.filter((currPhoto) => currPhoto != photo),
    );
  };

  const handleCropped = (photo) => {
    updateField('photos', [...details.photos, photo]);
    setShowModal(false);
  };

  const units = [
    { value: 'lb', label: 'lb' },
    { value: 'oz', label: 'oz' },
    { value: 'gal', label: 'gal' },
    { value: 'half-gal', label: 'half-gal' },
    { value: 'qt', label: 'qt' },
    { value: 'pt', label: 'pt' },
    { value: 'pk', label: 'pk' },
    { value: 'ea', label: 'ea' },
    { value: 'ct', label: 'ct' },
  ];

  return (
    <Page>
      <PageButtonsBar
        buttons={
          <>
            <Button
              label="Cancel"
              color="gray"
              variant="tertiary"
              action={() => navigate('/items')}
            />
            <Button
              color="error"
              variant="tertiary"
              style={{ marginRight: 'auto' }}
              label={itemId == 'new' ? 'Start Over' : 'Discard'}
              action={() => {
                // if (itemId != 'new') {
                setDetails(itemDetails);
                setAddOns(itemDetails.addOns);
                setRestrictions({
                  vegetarian: itemDetails?.restrictions?.includes('vegetarian'),
                  vegan: itemDetails?.restrictions?.includes('vegan'),
                  halal: itemDetails?.restrictions?.includes('halal'),
                  kosher: itemDetails?.restrictions?.includes('kosher'),
                });
                // } else setDetails()
              }}
              iconLeft={itemId == 'new' ? 'fa fa-undo' : 'fas fa-trash-alt'}
            />
            <Button
              label={
                itemId == 'new'
                  ? `Create ${!permissions.create.includes('items') ? 'Pending' : ''} Item`
                  : 'Save Changes'
              }
              action={handleSave}
              style={{ marginLeft: 'auto' }} // for small screens
              color="emerald"
              variant="primary"
            />
          </>
        }
      />
      <TwoColumn
        colLeft={
          <>
            {/* <h2 className={css["col-title"]}>Item Details</h2> */}
            <div className={css['left']}>
              <InputWrap
                label="Name"
                component={
                  <input
                    type="text"
                    value={details.name}
                    onChange={(e) => updateField('name', e.target.value)}
                    placeholder='e.g. "Romaine Lettuce"'
                  />
                }
              />
              <div className={css['half-input']}>
                <InputWrap
                  label="Price ($)"
                  component={
                    <input
                      type="number"
                      value={details.price}
                      onChange={(e) => updateField('price', e.target.value)}
                      min="0"
                    />
                  }
                />
                <InputWrap
                  label="Quantity"
                  component={
                    <div className={css['quantity-selector']}>
                      <input
                        type="number"
                        value={details.qty.value}
                        onChange={(e) =>
                          updateField('qty', { ...details.qty, value: e.target.value })
                        }
                        min="0"
                      />

                      <select
                        onChange={(e) => {
                          updateField('qty', { ...details.qty, units: e.target.value });
                        }}
                      >
                        {units.map((unit) => {
                          return (
                            <option selected={details.qty.units == unit.value} value={unit.value}>
                              {unit.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  }
                />
              </div>

              <InputWrap
                label="Description"
                boxStyles={{ height: '100%' }}
                component={
                  <textarea
                    style={{ height: '100%' }}
                    value={details.description}
                    onChange={(e) => updateField('description', e.target.value)}
                    placeholder="Add a brief, but interesting description of your item here"
                  />
                }
              />
            </div>
          </>
        }
        colRight={
          <div className={css['right']}>
            {/* <h2 className={css["col-title"]}>Add-ons</h2> */}
            <div className={css['box']}>
              <div className={css['checkbox-section']}>
                <h3>Dietary Restrictions</h3>
                <Checkbox
                  onChange={(e) =>
                    setRestrictions({
                      ...restrictions,
                      vegetarian: e.target.checked,
                    })
                  }
                  label="Vegetarian"
                  name="vegetarian"
                  value={restrictions.vegetarian}
                  // defaultChecked={itemDetails.restrictions.includes('vegetarian')}
                />
                <Checkbox
                  onChange={(e) =>
                    setRestrictions({
                      ...restrictions,
                      vegan: e.target.checked,
                    })
                  }
                  label="Vegan"
                  name="vegan"
                  value={restrictions.vegan}
                  // defaultChecked={itemDetails.restrictions.includes('vegan')}
                />
              </div>

              <div className={css['checkbox-section']}>
                <h3>Religious Restrictions</h3>
                <Checkbox
                  onChange={(e) =>
                    setRestrictions({
                      ...restrictions,
                      halal: e.target.checked,
                    })
                  }
                  label="Halal"
                  name="halal"
                  value={restrictions.halal}
                  // defaultChecked={itemDetails.restrictions.includes('halal')}
                />
                <Checkbox
                  onChange={(e) =>
                    setRestrictions({
                      ...restrictions,
                      kosher: e.target.checked,
                    })
                  }
                  label="Kosher"
                  name="kosher"
                  value={restrictions.kosher}
                  // defaultChecked={itemDetails.restrictions.includes('kosher')}
                />
              </div>
            </div>

            <div className={css['box']}>
              <Croppedimages
                images={details.photos}
                removeImage={removeImage}
                addImage={addImage}
                setImages={(images) => updateField('photos', images)}
              />
              <div className={css['image-buttons']}>
                <Button
                  label="Undo"
                  action={() => updateField('photos', itemDetails.photos)}
                  color="normal"
                  iconLeft="fas fa-undo"
                  variant="secondary"
                />

                <Button
                  color="error"
                  label="Remove Images"
                  action={() => updateField('photos', [])}
                  iconLeft="fa fa-trash-alt "
                  variant="tertiary"
                />
              </div>
            </div>
          </div>
        }
        colRightStyles={{
          padding: '0',
          backgroundColor: 'unset',
          boxShadow: 'unset',
          marginBottom: 8,
        }}
      />

      <div className={css.addons}>
        {addOns?.length > 0 &&
          addOns.map((addon, index) => {
            return (
              <AddonBox2
                // Addon
                handleTitle={(title) => updateAddon(index, 'title', title)}
                handleRequired={(required) => updateAddon(index, 'required', required)}
                handleLimit={(limit) => updateAddon(index, 'limit', limit)}
                handleRemove={(index) => removeAddon(index)}
                // Choice
                handleOption={(index) => addOption(index)}
                handleChoiceName={(name, choiceIndex) =>
                  updateAddonChoice(index, choiceIndex, name, 'name')
                }
                handleChoicePrice={(price, choiceIndex) =>
                  updateAddonChoice(index, choiceIndex, price, 'price')
                }
                handleRemoveChoice={(choiceIndex) => removeAddonChoice(index, choiceIndex)}
                // Other
                addOns={addOns}
                index={index}
                key={index}
              />
            );
          })}
      </div>

      <Button
      // high bottom margin for hovering button
        style={{ margin: '12px auto 64px' }}
        label="Add-on"
        iconLeft="fa fa-plus"
        action={() => addAddon()}
      />

      {showModal && (
        <CropModal
          closeFunction={() => setShowModal(false)}
          image={cropImage}
          hadnlecropped={handleCropped}
        />
      )}
    </Page>
  );
}
